module.exports = __webpack_public_path__ + "static/media/PaymentsAfrika.b809bf44.png";